import React, { useRef, useState, useEffect } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { Button, Box } from '@mui/material';

const placeholder = 'No Location';

const CountryTotalUsers = ({ data, title, subtitle }) => {
  const chartRef = useRef(null);
  // const [viewRange, setViewRange] = useState({ min: 0, max: 14 }); // show 8 bars at once
  // const itemsPerPage = 13;
  const itemsPerPage = 13;
const [viewRange, setViewRange] = useState({
  min: 0,
  max: data.length > itemsPerPage ? itemsPerPage - 1 : data.length - 1,
});


  const processedData = data.map((item) => ({
    ...item,
    category: item.category && item.category.trim() !== '' ? item.category : placeholder,
  }));

  const totalDataValue = data.reduce((acc, item) => acc + item.y, 0);

  const tooltipFormatter = function () {
    const percentage = (this.point.y / totalDataValue) * 100;
    return `<b>${this.series.name}</b><br/>${this.point.category}: ${this.point.y} (${percentage.toFixed(2)}%)`;
  };

  const dataLabelsFormatter = function () {
    const percentage = (this.y / totalDataValue) * 100;
    return `<span style="color: #916008;">(${percentage.toFixed(2)}%)</span> ${this.y}`;
  };

  const options = {
    chart: {
      type: 'bar',
      animation: true,
    },
    title: {
      text: `<span style="display: flex; align-items: center; font-weight:700;">
               <span style="width: 10px; height: 10px; background-color: #2E80DB; border-radius: 50%; margin-right: 8px; "></span>
               ${title}
             </span>`,
      useHTML: true,
      align: 'left',
      style: {
        color: '#757575',
        fontSize: '16px',
        fontWeight: '600',
      },
    },
    subtitle: {
      text: subtitle || `${totalDataValue.toLocaleString()} Total Users`,
      align: 'left',
      style: {
        color: '#000',
        fontSize: '24px',
        fontWeight: 'bold',
      },
    },
    xAxis: {
      categories: processedData.map((item) => item.category),
      min: viewRange.min,
      max: viewRange.max,
      gridLineWidth: 1,
      lineWidth: 0,
    },
    yAxis: {
      min: 0,
      title: { text: '' },
      labels: { enabled: false },
      gridLineWidth: 0,
    },
    tooltip: {
      valueSuffix: ' users',
      formatter: tooltipFormatter,
    },
    plotOptions: {
      bar: {
        borderRadius: 0,
        dataLabels: {
          enabled: true,
          formatter: dataLabelsFormatter,
          style: { fontWeight: 'bold', color: '#000' },
        },
        groupPadding: 0.1,
      },
    },
    legend: { enabled: false },
    credits: { enabled: false },
    series: [
      {
        name: '',
        color: '#2E80DB',
        data: processedData.map((item) => ({
          y: item.y,
          color: item.color || '#2E80DB',
          category: item.category,
        })),
      },
    ],
  };

  // Update chart view on button click
  const handleNext = () => {
    if (viewRange.max < processedData.length - 1) {
      const newMin = viewRange.min + itemsPerPage;
      const newMax = viewRange.max + itemsPerPage;
      setViewRange({ min: newMin, max: Math.min(newMax, processedData.length - 1) });
    }
  };

  const handlePrev = () => {
    if (viewRange.min > 0) {
      const newMin = Math.max(0, viewRange.min - itemsPerPage);
      const newMax = newMin + itemsPerPage - 1;
      setViewRange({ min: newMin, max: newMax });
    }
  };

  // Sync chart xAxis on range change
  useEffect(() => {
    if (chartRef.current && chartRef.current.chart) {
      const chart = chartRef.current.chart;
      chart.xAxis[0].setExtremes(viewRange.min, viewRange.max);
    }
  }, [viewRange]);

  useEffect(() => {
  if (data.length) {
    setViewRange({
      min: 0,
      max: data.length > itemsPerPage ? itemsPerPage - 1 : data.length - 1,
    });
  }
}, [data]);


  return (
    <Box className='border p-20 rounded-3'>
      <HighchartsReact highcharts={Highcharts} options={options} ref={chartRef} />
      <Box display="flex" justifyContent="end" mt={2} gap={2}>
        <Button variant="contained" onClick={handlePrev} disabled={viewRange.min === 0} sx={{textTransform:'capitalize', backgroundColor: '#BE1F1F', color: '#fff', '&:hover': { backgroundColor: '#FF4A4A' }}}>
         Previous
        </Button>
        <Button
          variant="contained"
          onClick={handleNext}
          disabled={viewRange.max >= processedData.length - 1}
          sx={{textTransform:'capitalize', backgroundColor: '#BE1F1F', color: '#fff', '&:hover': { backgroundColor: '#FF4A4A' }}}
        >
          Next
        </Button>
      </Box>
    </Box>
  );
};

export default CountryTotalUsers;
